<template>
  <div class="panel-container">
    <!-- 主体容器 -->
    <div class="main-container">
      <!-- 查询条件 -->
      <div class="top-container">
        <el-form class="form-container" label-position="top" :model="formData">
          <el-form-item :label="$str.getKey('收益管理/日期')">
            <el-date-picker v-model="formData.dateRange"  type="daterange" :clearable="false" :editable="false" :placeholder="$str.getKey('收益管理/请选择')" @change="timeRangeChange" :disabled-date="disabledDate">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$str.getKey('收益管理/操作人员')">
            <el-input v-model="formData.operator" @change="refreshHistoryList" clearable></el-input>
          </el-form-item>
          
          <el-form-item :label="$str.getKey('收益管理/电站')">
            <el-select class="station-select" v-model="formData.stationId" :placeholder="$str.getKey('收益管理/请选择电站')" filterable clearable @change="handleStationChange">
              <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$str.getKey('收益管理/电表')">
            <el-select class="meter-select" v-model="formData.meterId" :placeholder="$str.getKey('收益管理/请选择电表')" clearable filterable>
              <el-option v-for="item in meterList" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="refreshHistoryList " class="meter-feature-btn">{{ $str.getKey('收益管理/搜索') }}</el-button>
          </el-form-item>
        </el-form>


      </div>
      
      <!-- 表格区域 -->
      <div class="table-container">
        <el-table :data="tableData" stripe v-loading="loading">
          <el-table-column prop="time" :label="$str.getKey('收益管理/操作时间')" width="200" />
          <el-table-column prop="operator" :label="$str.getKey('收益管理/操作人')" width="180" />
          <el-table-column prop="details" :label="$str.getKey('收益管理/修改内容')" />
        </el-table>
      </div>

      <!-- 分页区域 -->
      <div class="foolter-container">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handlePageChange" :disabled="loading"
          v-model:current-page="pageCtrl.currentPage" :page-size="pageCtrl.pageSize" :total="pageCtrl.total" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, watch, inject } from "vue"
import dayjs from 'dayjs';
import { queryStationList, queryMeterList, queryHistoryLog } from '../api/index.js';

const $str = window.$str;

const trackEvent = inject('trackEvent'); 
const trackEventTypes = inject('trackEventTypes');
const trackDatas = reactive({
  commitSearch: {
    targetId: '',
    refData: {
      targetName: '电表设置/操作历史/搜索按钮',
      desc: '执行搜索'
    },
  },
})


const loading = ref(false); // 控制加载中动效的渲染

const stationList = ref([]); // 存储【电站列表】的下拉选项
const meterList = ref([]); // 存储【目标电站下电表列表】的下拉选项
const tableData = ref([]); // 列表数据


// 表单对应的数据对象
const formData = reactive({
  // dateRange: [dayjs(), dayjs()],
  dateRange: [dayjs().subtract(1, 'month').toDate(), dayjs().toDate()],
  operator: '',
  stationId: '',
  meterId: '',
})


// 页码控制器
const pageCtrl = reactive({ // 页码控制器
  total: 0,
  currentPage: 1,
  pageSize: 10,
  pageSizes: [10, 20, 50]
});


initPanel();

// 仅在点击“搜索”时刷新列表，避免筛选未完成时触发请求



/** ====== [业务：功能方法] =================================================================== */
/** 初始化面板 */
function initPanel() {
  getStationList();
  // refreshHistoryList(); 
}

/** 设置日期的禁选范围 */
function disabledDate(date) {
  return date > dayjs() || date < dayjs().subtract(6, 'month').startOf('month');
}


/** 响应选择月份发生变化 */
function timeRangeChange(value) {
  refreshHistoryList();
}

/** 事件响应：页码发生变化 */
function handlePageChange(pageNum) {
  pageCtrl.currentPage = pageNum;
  refreshHistoryList();
}


/** 事件响应：选择的电站发生变化 */
function handleStationChange(value) {
  if (value) {
    formData.meterId = '';
    getMeterList(value);
  }
}




/** ====== [辅助：功能方法] =================================================================== */

/** 获取：电站列表的下拉选项 */
function getStationList() {
  const params = {
    pageNum: 1,
    pageSize: 9999,
  }
  queryStationList(params).then(res => {
    if (Array.isArray(res?.rows)) {
      stationList.value = res.rows.map(it => {
        return {
          name: it.name ?? it.stationName ?? it.station?.name ?? '',
          id: it.stationId ?? it.id ?? it.station?.id
        }
      })
    } else {
      stationList.value = [];
    }
  })
}

/** 获取：电表列表的下拉选项 */
function getMeterList(stationId) {
  const params = {
    stationId,
    meterType: 3, // 1-关口电表， 3-并网点电表
  }
  queryMeterList(params).then(res => {
    if (Array.isArray(res?.rows) && res.rows.length > 0) {
      meterList.value = res.rows.map(it => {
        return {
          name: it.meterName,
          uuid: it.uuid,
          devId: it.devId,
          productModel: it.productModel,
          meterType: it.meterType,
        }
      })
    } else {
      meterList.value = [];
    }
  })
}


/** 刷新表格数据 */
function refreshHistoryList() {
  const params = {
    startDate: dayjs(formData.dateRange[0]).format('YYYY-MM-DD'),
    endDate: dayjs(formData.dateRange[1]).format('YYYY-MM-DD'),
    uuid: formData.meterId,
    createBy: formData.operator, 
    pageSize: pageCtrl.pageSize,
    pageNum: pageCtrl.currentPage,
  }

  loading.value = true;
  queryHistoryLog(params).then(res => {
    pageCtrl.total = res?.total ?? 0;
    if (Array.isArray(res.rows)) {
      tableData.value = res.rows.map(it => {
        const operateInfo = {
          time: it.executeTime,
          operator: it.createBy,
          device: it.devId,
          details: it.timeTable,
        }
        return operateInfo;
      });
    }
  }).finally(() => {
    loading.value = false;
    
    // 埋点信息：
    trackDatas.commitSearch.refData['stationId'] = formData.stationId;
    trackDatas.commitSearch.refData['meterUuid'] = formData.meterId;
    trackDatas.commitSearch.refData['dateRange'] = [params.startDate, params.endDate];
    trackDatas.commitSearch.refData['operator'] = params.createBy;
    trackDatas.commitSearch.refData['pageNum'] = params.pageNum;
    trackDatas.commitSearch.refData['pageSize'] = params.pageSize;
    
    trackEvent(trackEventTypes.search, trackDatas.commitSearch);
  });
}


</script>
<style lang="scss" scoped>
@import '../button-style.scss';

.panel-container {
  & {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    padding: 10px;
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .main-container {
    & {
      width: 100%;
      height: 100%;
      flex: 1;
      overflow: hidden;
      padding: 10px;
      display: flex;
      flex-direction: column;
    }

    .top-container {
      .form-container {
        display: grid;
        grid-template-columns: minmax(260px, 1.2fr) minmax(180px, 0.9fr) minmax(220px, 1fr) minmax(220px, 1fr) auto;
        gap: 10px 12px;
        align-items: end;
      }

      .form-container :deep(.el-form-item) {
        margin-bottom: 0;
      }

      .form-container :deep(.el-form-item__label) {
        font-size: 12px;
        color: rgba(46, 46, 46, 0.65);
        line-height: 1.3;
        margin-bottom: 6px;
        padding: 0;
      }

      .form-container :deep(.el-date-editor),
      .form-container :deep(.el-input),
      .form-container :deep(.el-select) {
        width: 100%;
      }

      /* 电站/电表选择框稍加长，保证可选择与可读性 */
      .form-container :deep(.station-select),
      .form-container :deep(.meter-select) {
        min-width: 220px;
      }

      @media (max-width: 980px) {
        .form-container {
          grid-template-columns: 1fr 1fr;
        }
      }

    }

    .table-container {
      width: 100%;
      min-height: 480px;
      flex: 1;
      display: grid;
      grid-template-rows: 1fr;
      .el-table {
        width: 100%;
        height: 100%;
      }
    }

    .foolter-container {
      width: 100%;
      height: 50px;
      margin-top: 10px;
      padding: 10px 0;
      display: flex;
      justify-content: flex-end;

    }
  }

}


</style>
